import styled from 'styled-components'

export const CardConnectionS = styled.div`
  padding: ${({ theme }) => theme.metrics.space4};
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => theme.colors.white};
`
